import { Button } from "@/components/ui/button";
import { Loader2 } from "lucide-react";
import { useTranslation } from "react-i18next";

interface EmailRecipientsAddUsersSubmitButtonProps {
  onSubmit: () => Promise<void>;
  isSubmitting: boolean;
}

export const EmailRecipientsAddUsersSubmitButton = ({
  onSubmit,
  isSubmitting,
}: EmailRecipientsAddUsersSubmitButtonProps) => {
  const { t } = useTranslation();
  return (
    <Button
      data-testid="email-recipients-add-users-submit-button"
      onClick={onSubmit}
      disabled={isSubmitting}
    >
      {isSubmitting && <Loader2 className="w-4 h-4 animate-spin mr-2" />}
      {t("emailRecipients.addUsers.submit")}
    </Button>
  );
};
